import { SelectInput } from "@src/components/ui-components/Selectors/SelectInput/SelectInput";
import { fetchPropertyUnit, useAPIUnits } from "@src/data-hooks/unit/unit.service";
import { convertOptionalArrayToArray, getStringArray } from "@src/utils/arrayUtilities";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { UnitData } from "../../../Property/Units/UnitData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";

export class CustomFieldTenantDataType extends CustomFieldDataTypeHelper<UnitData[]> {
  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setRawData: (data: string[] | undefined) => void
  ): JSX.Element {
    return <CustomFieldUnitDataTypeEditor data={data} context={context} setRawData={setRawData} />;
  }
  override getStringRepresentation(data: any, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    const propertyID = context.propertyID;
    if (!propertyID) return "";

    const unitIDs: string[] = convertOptionalArrayToArray(data);
    if (unitIDs.length === 0) return "";

    return Promise.all(unitIDs.map((unitID) => fetchPropertyUnit({ propertyID: propertyID, unitID }).catch(() => undefined))).then((units) => {
      const unitNames = units
        .filter((unit) => unit !== undefined)
        .map((unit) => unit.name)
        .join(", ");

      return unitNames;
    });
  }
}

const CustomFieldUnitDataTypeEditor = ({
  data,
  context,
  setRawData,
}: {
  data: any | undefined;
  context: DataEditorContext;
  setRawData: (data: string[] | undefined) => void;
}) => {
  const { $units, units } = useAPIUnits({ propertyID: context.propertyID });

  return (
    <SelectInput
      isMulti
      width="100%"
      isFetching={$units.isLoading}
      options={units?.map((contractor) => ({ value: contractor.id, label: contractor.name })) ?? []}
      value={getStringArray(data)}
      onChange={(selected) => setRawData([...selected])}
    />
  );
};
